import client from './client';

// The register of outside agencies that turn up to fires: municipal fire
// departments, private services, government bodies, NGOs. Global rather than
// tenant-scoped — one brigade assists many FPAs — so nothing here takes a
// tenant_id. Writes are super-admin only; reads go to anyone who can file a
// report, since the mutual-aid picker cannot render without them.

export const listOrganisations = (params) =>
  client.get('/organisations', { params }).then((r) => r.data);

// Includes the station list; the plain list route deliberately omits it.
export const getOrganisation = (id) =>
  client.get(`/organisations/${id}`).then((r) => r.data);

export const createOrganisation = (data) =>
  client.post('/organisations', data).then((r) => r.data);

export const updateOrganisation = (id, data) =>
  client.put(`/organisations/${id}`, data).then((r) => r.data);

// Prefer updateOrganisation({ is_active: false }). Deleting drops the stations
// too and the id never resolves again; mutual-aid entries keep the name they
// denormalised, so past reports survive either way.
export const deleteOrganisation = (id) =>
  client.delete(`/organisations/${id}`).then((r) => r.data);

// -- Stations -------------------------------------------------------------

export const listStations = (organisationId) =>
  client.get(`/organisations/${organisationId}/stations`).then((r) => r.data);

export const createStation = (organisationId, data) =>
  client.post(`/organisations/${organisationId}/stations`, data).then((r) => r.data);

export const updateStation = (organisationId, stationId, data) =>
  client
    .put(`/organisations/${organisationId}/stations/${stationId}`, data)
    .then((r) => r.data);

export const deleteStation = (organisationId, stationId) =>
  client
    .delete(`/organisations/${organisationId}/stations/${stationId}`)
    .then((r) => r.data);

export const ORG_TYPES = [
  { value: 'fire_department', label: 'Fire department' },
  { value: 'private_service', label: 'Private service' },
  { value: 'government', label: 'Government' },
  { value: 'ngo', label: 'NGO' },
  { value: 'other', label: 'Other' },
];

export const ORG_TYPE_LABELS = ORG_TYPES.reduce((acc, t) => {
  acc[t.value] = t.label;
  return acc;
}, {});
